import React from 'react';
import { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

interface PageHeaderProps {
  title: string;
  description?: string;
  icon: React.ReactElement<LucideIcon>;
  iconGradient?: 'blue' | 'purple' | 'green' | 'pink' | 'orange' | 'violet' | 'emerald' | 'rose';
  actions?: React.ReactNode;
  className?: string;
}

const gradientMap = {
  blue: 'from-blue-500 to-indigo-600',
  purple: 'from-purple-500 to-pink-600',
  green: 'from-green-500 to-emerald-600',
  pink: 'from-pink-500 to-rose-600',
  orange: 'from-orange-500 to-amber-600',
  violet: 'from-violet-500 to-purple-600',
  emerald: 'from-emerald-500 to-green-600',
  rose: 'from-rose-500 to-pink-600',
};

export function PageHeader({
  title,
  description,
  icon,
  iconGradient = 'blue',
  actions,
  className,
}: PageHeaderProps) {
  return (
    <div className={cn('flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4', className)}>
      <div className="flex items-center gap-3">
        <div
          className={cn(
            'flex items-center justify-center w-12 h-12 rounded-xl shadow-lg bg-gradient-to-br',
            gradientMap[iconGradient]
          )}
        >
          {React.cloneElement(icon, { className: 'h-6 w-6 text-white' })}
        </div>
        <div>
          <h1 className="text-2xl lg:text-3xl font-bold text-slate-900">{title}</h1>
          {description && <p className="text-slate-500 mt-0.5">{description}</p>}
        </div>
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
